import { Button, List, ListItem, Popover, Typography, useTheme } from '@mui/material';
import { styled } from '@mui/material/styles';
import { type FC, useEffect, useState } from 'react';

const StyledButton = styled(Button)(
  ({ theme }) => `
    background-color: ${theme.colors.avani.turc};
    border-radius: 8px;
    border: none;
    color: white;
    padding: 8px 12px;

    &:hover {
      border: none;
      color: ${theme.colors.avani.darkTitleText};

      .MuiSvgIcon-root {
        color: ${theme.colors.avani.darkTitleText};
      }
    }
`
);

const StyledListItem = styled(ListItem)(
  () => `
  cursor: pointer;
  display: flex;

  svg {
    margin-right: 12px;
  }
`
);

interface IProps {
  typeX: 'Trend' | 'Range';
  outOfX: boolean | undefined;
  setIsOutOfX: (val: boolean | undefined) => void;
  outOfXOptions?: boolean[];
}

export const FilterBooleanOutOfXDropdown: FC<IProps> = ({ outOfX, setIsOutOfX, outOfXOptions, typeX }) => {
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const open = Boolean(anchorEl);
  const [buttonLabel, setButtonLabel] = useState<string>(`All ${typeX}s`);

  useEffect(() => {
    if (outOfXOptions?.length === 1) {
      setButtonLabel(outOfXOptions[0] ? `Out of ${typeX}` : `In ${typeX}`);
    } else {
      switch (outOfX) {
        case true:
          setButtonLabel(`Out of ${typeX}`);
          break;
        case false:
          setButtonLabel(`In ${typeX}`);
          break;
        default:
          setButtonLabel(`All ${typeX}s`);
          break;
      }
    }
    //todo:v2-changes
  }, [outOfX, outOfXOptions]);

  return (
    <>
      <StyledButton
        variant="outlined"
        disabled={!outOfXOptions?.length}
        onClick={(e) => setAnchorEl(e.currentTarget)}
        sx={{
          backgroundColor: 'white',
          border: `2px solid ${theme.colors.avani.magenta}`,
          color: theme.colors.avani.teal,
          paddingTop: '8px',
          borderRadius: '32px',
          [`&:hover`]: { border: `2px solid ${theme.colors.avani.magenta}`, color: theme.colors.avani.magenta }
        }}
      >
        {buttonLabel}
      </StyledButton>
      <Popover
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{ vertical: 'center', horizontal: 'left' }}
        onClose={() => setAnchorEl(null)}
      >
        <List>
          {!!outOfXOptions?.length && (
            <>
              {outOfXOptions.length > 1 && (
                <StyledListItem
                  key={'all'}
                  value={'All'}
                  onClick={() => {
                    setIsOutOfX(undefined);
                    setButtonLabel(`All ${typeX}s`);
                    setAnchorEl(null);
                  }}
                >
                  <Typography sx={{ flexGrow: 1, pt: '3px' }}>All</Typography>
                </StyledListItem>
              )}
              {outOfXOptions.map((option, index) => {
                return (
                  <StyledListItem
                    key={index}
                    value={option ? `Out of ${typeX}` : `In ${typeX}`}
                    onClick={() => {
                      setIsOutOfX(option);
                      setButtonLabel(option ? `Out of ${typeX}` : `In ${typeX}`);
                      setAnchorEl(null);
                    }}
                  >
                    <Typography sx={{ flexGrow: 1, pt: '3px' }}>
                      {option ? `Out of ${typeX}` : `In ${typeX}`}
                    </Typography>
                  </StyledListItem>
                );
              })}
            </>
          )}
        </List>
      </Popover>
    </>
  );
};
